import Point from "./Point";
import { compareProperties, copyAllProperties, copyProperties } from "./utils";

export class PageUsage {
  compareTo(other: PageUsage): any {
    return compareProperties(this, other, ...this.getPersistentProperties());
  }
  _position = new Point(0, 0);
  pageId: string = "";

  // non persistent
  sourceId: string | undefined; // only used for copy

  // to debug
  set position(point: Point) {
    this._position = point;
  }
  get position(): Point {
    return this._position;
  }

  constructor(data?: any) {
    copyAllProperties(data, this);
  }

  getPersistentProperties(): string[] {
    return ["position", "pageId"]; // no itx
  }

  toJSON(): any {
    const res = copyProperties(this, {});
    return res;
  }

  fromJSON(data: any): void {
    this._position.fromJSON(data.position);
    this.pageId = data.pageId;
  }
  //////////////////////////////////////////////////////
  ///////////// for paste
  mapAfterCopy() {
    if (this.sourceId) {
      // mapAfterCopy called twice, no error
    } else {
      const page = state.objectRegistry.getObject(this.pageId);
      if (page) {
        //
        // make sure page is mapped first !!!
        // mnormal mapping is not allow because page has propertyId !!!!!
        //
        if (page.sourceId == undefined) {
          page.mapAfterCopy();
        }
        this.sourceId = this.pageId;
        this.pageId = page.id;
      }
    }
  }
}
